export const trackEvent = (eventName: string, params: Record<string, unknown> = {}) => {
  if (typeof window === 'undefined' || !window.dataLayer) {
    return
  }
  window.dataLayer.push({ event: eventName, ...params })
}
